// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgressBar_wrapper__ZyWqw","progress":"ProgressBar_progress__33Q1C"};